import { render, staticRenderFns } from "./CreateTariffPackagesModal.vue?vue&type=template&id=d5e3b40e&scoped=true&"
import script from "./CreateTariffPackagesModal.vue?vue&type=script&lang=js&"
export * from "./CreateTariffPackagesModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTariffPackagesModal.vue?vue&type=style&index=0&id=d5e3b40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e3b40e",
  null
  
)

export default component.exports